import React from "react";
// hook
import { useStyles } from "../hooks/table.useStyles";
// language
import { useLocale } from "../../../modules/hooks/UseLocale";
// UI
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Button from "@material-ui/core/Button";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
// method
import { setSortData } from "../methods/common.methods";
// constants
import { TabKey } from "../MasterMaintenance.constants";

export const MasterMaintenanceUserMasterTbody = (props: any) => {
  const {
    pageInfo,
    order,
    orderBy,
    serviceCenterDataList,
    userRepairDisabledFlag,
  } = props;
  const classes = useStyles();
  const { t } = useLocale({
    defaultPath: "modules.components.MasterMaintenance.userMaster",
  });

  return (
    <TableBody>
      {setSortData(props.data, order, orderBy)
        .slice(
          pageInfo.page * pageInfo.rowsPerPage,
          pageInfo.page * pageInfo.rowsPerPage + pageInfo.rowsPerPage
        )
        .map((row: any, index: number) => {
          const serviceCenterName = serviceCenterDataList.filter(
            (item: any) =>
              item.service_center_id === row.userinfo_repair.service_center
          );
          return (
            <TableRow className={classes.tbody} hover tabIndex={-1} key={index}>
              <TableCell>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<EditIcon />}
                  onClick={() => props.handleEdit(row, TabKey.useMaster)}
                >
                  {t("edit")}
                </Button>
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<DeleteIcon />}
                  onClick={() => props.handleDelete(row)}
                >
                  {t("delete")}
                </Button>
              </TableCell>
              <TableCell className={classes.nowrap}>{row.given_name}</TableCell>
              <TableCell className={classes.nowrap}>
                {row.family_name}
              </TableCell>
              <TableCell className={classes.nowrap}>
                {row.middle_name}
              </TableCell>
              <TableCell className={classes.nowrap}>
                {row.affiliate_cd}
              </TableCell>
              <TableCell className={classes.nowrap}>
                {row.primary_locale !== "" && row.primary_locale !== undefined
                  ? row.primary_locale.toLocaleUpperCase()
                  : ""}
              </TableCell>
              <TableCell className={classes.nowrap}>{row.tel_no}</TableCell>
              <TableCell className={classes.nowrap}>
                {row.mail_address}
              </TableCell>
              {userRepairDisabledFlag && (
                <TableCell className={classes.nowrap}>
                  {row.userinfo_repair.erp_user_id}
                </TableCell>
              )}
              {userRepairDisabledFlag && (
                <TableCell className={classes.nowrap}>
                  {serviceCenterName.length > 0
                    ? serviceCenterName[0].name
                    : ""}
                </TableCell>
              )}
              <TableCell className={classes.nowrap}>
                {row.user_block ? "Y" : "N"}
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<EditIcon />}
                  onClick={() => props.handleEdit(row, TabKey.useMaster)}
                >
                  {t("edit")}
                </Button>
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<DeleteIcon />}
                  onClick={() => props.handleDelete(row)}
                >
                  {t("delete")}
                </Button>
              </TableCell>
            </TableRow>
          );
        })}
    </TableBody>
  );
};
